var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"NotFound"},[_c('div',{staticClass:"NotFound_box"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v("Back to home")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700390d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = null
// module chunks = 